// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2342 ? "skylab.popsheet" : chunkId) + "." + {"2342":"aadd820b44212f60b000","4199":"4a290e666c75449cd325"}[chunkId] + ".js";
};